const notificationMap = (order) => {
  let label = null
  // Convert both dates to milliseconds
  let date1Ms = new Date(order.created_at).getTime()
  let date2Ms = new Date().getTime()
  let differenceMs = date2Ms - date1Ms
  let sec = differenceMs / 1000
  if (sec < 86399 && order.status === 'new') {
    label = 'new'
  } else {
    label = 'earlier'
  }

  return {
    ...order,
    label
  }
}

export {
  notificationMap
}
